<template lang="pug">
  b-row.justify-content-md-center
    ReloadAppDialog(:showDialog="showDialog")
    b-col(md="9" offset-md="3")
      h4 Reclamos Ecommerce
    b-col(md="3")
      last-activity(:ecommerce="true")

    b-col(md="9")
      b-row
        b-col(md="4")
          b-nav.nav-pills
            li.nav-item.filters-title Filtrar por:
            li.nav-item
              b-button(variant="primary" ,:pressed.sync="pending" ,@click="showPending($event)") Pendientes
                span(v-if="pending") &nbsp;&nbsp;
                icon(name="check" v-if="pending")
            li.nav-item
              b-button(variant="link" ,@click="toggleAge")
                icon(name="chevron-down" v-if="sortAge" )
                icon(name="chevron-up" v-else)
                | Edad
        b-col(md="8")
          b-input-group
            b-form-input(v-model="filterText", @keyup.enter.native="showPending")
            b-input-group-button(slot='right')
              b-btn(variant="primary" ,@click="showPending")
                icon(name="search")
      b-table(hover ,:fields="complaintFields" ,:items="complaints" ,@row-clicked="showComplaintDetails"
        v-if="complaints.length > 0")
        template(slot="status" scope="thisComplaint")
           .complaint-status-wrapper(:class="`status-${statuses[thisComplaint.item.aasm_state].initials.toLowerCase()}`"
           ,:id="`status-${thisComplaint.item._id.$oid}`") {{ statuses[thisComplaint.item.aasm_state].initials }}
           complaint-popover(:thisComplaint="thisComplaint.item" ,:popoverTarget="`status-${thisComplaint.item._id.$oid}`")
        template(slot="token" scope="thisComplaint") {{ thisComplaint.item.ticket_info.booking_number }}

        template(slot="category" scope="thisComplaint") {{ thisComplaint.item.complaint_category.name }}

        template(slot="comment" scope="thisComplaint")
          div.ellipsis(:id="`comment-${thisComplaint.item._id.$oid}`") {{ thisComplaint.item.comment }}
          complaint-popover(:thisComplaint="thisComplaint.item"
            ,:popoverTarget="`comment-${thisComplaint.item._id.$oid}`")

        template(slot="age" scope="thisComplaint") {{ complaintAge(thisComplaint.item) }}

        template(slot="bus_operator" scope="thisComplaint") {{ busOperators(thisComplaint.item) }}

        template(slot="amount_requested" scope="thisComplaint")
          div(v-if="thisComplaint.item.reimbursement")
            span(v-if="thisComplaint.item.reimbursement.compensation_type === 'm'")
              template(v-if="['WebPay', 'Agencia', 'Fintoc', 'OneClick', 'Mercado Pago', 'Floid'].includes(thisComplaint.item.ticket_info.payment_method)")
                | {{ thisComplaint.item.reimbursement.amount | currency('CLP $', 0, { thousandsSeparator: '.'}) }}
              template(v-else)
                | {{ thisComplaint.item.reimbursement.amount | currency('USD $', 2, { thousandsSeparator: ',', decimalSeparator: '.' }) }}
            span(v-else) No monetario
          div(v-else-if="thisComplaint.item.aasm_state === 'rejected'") Reclamo rechazado
          div(v-else) Aún no está cerrado

        template(slot="edit_complaint" scope="thisComplaint")
          router-link(:to="{ name: 'show_complaint', params: { complaint_id: thisComplaint.item._id.$oid } }").show-link
      div.no-complaints-left(v-else)
        b-alert(show variant="warning") No se encontraron reclamos

      b-pagination(align="center" ,:total-rows="pagination.total" v-model="pagination.current"
        ,:per-page="pagination.per_page" ,@change="changePage" v-if="complaints.length > 0")
</template>

<script scoped>
import store from '@/store';
import constants from '@/constants/Status.constants';
import kexaApi from '@/services/apiService';
import LastActivity from '@/components/layout/LastActivity';
import complaintPopover from '@/components/layout/PopoverDetail';
import dateService from '@/utils/dateService';

const parse = require('parse-link-header');

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

export default {
  name: 'complaints',
  components: {
    LastActivity,
    complaintPopover,
  },
  data() {
    return {
      complaintFields: {
        number: {
          label: 'ID',
          sortable: true,
        },
        status: {
          label: 'Estado',
          tdClass: 'status-holder',
        },
        token: { label: 'Número de compra' },
        category: {
          label: 'Categoría',
          sortable: true,
        },
        age: { label: 'Edad' },
        bus_operator: { label: 'Empresa de bus' },
      },
      statuses: constants.STATUSES_ECOMMERCE,
      complaints: [],
      pagination: {},
      current_page: 1,
      pending: true,
      sortAge: false,
      filterText: '',
      intervalId: null,
      showDialog: false,
    };
  },
  created() {
    this.fetchComplaints(undefined, true);
  },
  methods: {
    busOperators(complaint) {
      const busOperators = complaint.ticket_info.bus_operators;

      if (busOperators.length > 1) {
        return String(busOperators).replace(',', ', ');
      }
      return String(busOperators);
    },
    complaintAge(complaint) {
      return dateService.complaintAge(complaint.created_at);
    },
    fetchComplaints(page, pending) {
      const $this = this;
      kexaApi.complaints(page, pending, this.filterText, this.sortAge, true)
        .then((data) => {
          $this.complaints = data.body.complaints;
          $this.setPagination(data);
        });
    },
    setPagination(res) {
      const links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links')
        ? parse(res.headers.map.link[0])
        : null;
      const current = res.body.meta.current_page;
      const total = res.body.meta.total_count;
      const perPage = res.body.meta.per_page;
      const pagination = {
        current: parseInt(current, 10),
        total: parseInt(total, 10),
        per_page: parseInt(perPage, 10),
        ...links,
      };
      this.pagination = pagination;
    },
    changePage(page) {
      this.current_page = page;
      this.fetchComplaints(page, this.pending);
    },
    showComplaintDetails(complaint) {
      store.commit('selectComplaint', complaint);
      this.$router.push(`/complaints_ecommerce/${complaint._id.$oid}`);
    },
    showPending() {
      this.fetchComplaints(null, this.pending);
    },
    refreshComplaints() {
      const $this = this;
      this.intervalId = setInterval(() => {
        $this.fetchComplaints(undefined, $this.pending);
      }, 120000);
    },
    toggleAge() {
      this.sortAge = !this.sortAge;
      this.fetchComplaints(this.current_page, this.pending);
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  mounted() {
    this.refreshComplaints();
    this.refreshReloaAppStatus();
    if (store.state.reloadApp) {
      this.showDialog = true;
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  @import '../../assets/css/kexa-variables';

  .description-container {
    max-height: 74px;
    overflow-y: scroll;
  }
  .b-table {
    font: {
      size: 13px;
    }
    margin: {
      top: 12px;
    }
    tr {
      cursor: pointer;
    }
    td {
      padding: 0.65rem;
      &.status-holder {
        text: {
          align: center;
          transform: lowercase;
        }
      }
    }
  }
  [id^="comment-"] {
    cursor: pointer;
  }
  .tabs-container {
    border-radius: 0;
    .card-header {
      background: {
        color: #FFF;
      }
      .nav-item > .nav-link {
        color: #000;
        &:hover {
          color: #666;
        }
      }
    }
  }
  .filters-title {
    padding: {
      top: 6px;
      right: 12px;
    }
  }
  .no-complaints-left {
    padding: {
      top: 100px;
    }
    text: {
      align: center;
    }
  }
  .alert {
    padding: {
      top: 2rem;
      bottom: 2rem;
    }
    margin: {
      right: 10rem;
      left: 10rem;
    }
  }
  .ellipsis {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/complaints/ComplaintsEcommerce.vue